// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'condition-critical';

export const Component = () => (
  <path fill='currentColor' stroke='currentColor' d='m2 9 3.5-6h7L16 9l-3.5 6h-7z' />
);

export const viewBox = '0 0 18 18';
